"use strict";
exports.__esModule = true;
exports.PhoneLabel = exports.EmailLabel = void 0;
var EmailLabel;
(function (EmailLabel) {
    EmailLabel["WORK"] = "Work";
    EmailLabel["PERSONAL"] = "Personal";
    EmailLabel["OTHER"] = "Other";
})(EmailLabel = exports.EmailLabel || (exports.EmailLabel = {}));
var PhoneLabel;
(function (PhoneLabel) {
    PhoneLabel["WORK"] = "Work";
    PhoneLabel["PERSONAL"] = "Personal";
    PhoneLabel["OTHER"] = "Other";
})(PhoneLabel = exports.PhoneLabel || (exports.PhoneLabel = {}));
